module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_10.9ccc568f.svg";